/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    ITlsFingerprintMatch,
    MatchOperation,
} from 'generated-types';

import { StringService } from 'string-service';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { TlsFingerprintMatch } from 'object-types';

/**
 * @description  TLS Fingerprint Match ConfigItem class.
 * @author Sarthak Kapoor
 */
export class TlsFingerprintMatchConfigItem extends MessageItem<ITlsFingerprintMatch> {
    public static ajsDependencies = ['stringService'];

    constructor(args = {}) {
        const extendedArgs = {
            objectType: TlsFingerprintMatch,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Return the array of the group_refs names.
     */
    public get stringGroupRefNames(): string[] {
        const stringService: StringService = this.getAjsDependency_('stringService');
        const { string_group_refs: stringGroupRefs = [] } = this.config;

        return stringGroupRefs.map((ref: string) => stringService.name(ref));
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<ITlsFingerprintMatch> {
        const defaultValues = this.getAjsDependency_('defaultValues');
        const defaultConfig = defaultValues.getDefaultItemConfigByType(this.objectType) || {};

        return {
            ...defaultConfig,
            match_operation: MatchOperation.IS_IN,
        };
    }
}
